import React from "react"
import {IcomoonIconName} from "../Icon/icons"
import Card from "../../containers/Card/Card"
import useAccordionList from "../../hooks/useAccordionList"
import {Accordion, AccordionTheme} from "../Accordion/Accordion"

interface AccordionListProps {
	title: string
	theme: AccordionTheme
	allowMultipleExpanded?: boolean
	items: Array<{title: React.ReactNode | string; icon?: IcomoonIconName; content: React.ReactNode}>
}

export default function AccordionList({theme, items, title, allowMultipleExpanded = false}: AccordionListProps) {
	const {handleExpand, expandedIndices} = useAccordionList({numOfItems: items.length, allowMultipleExpanded})

	return (
		<Card className="accordion-list" title={title}>
			{items.map((item, index) => (
				<Accordion
					key={index}
					theme={theme}
					icon={item.icon}
					title={item.title}
					uncontrolled={{expanded: expandedIndices[index], onExpand: () => handleExpand(index)}}
				>
					{item.content}
				</Accordion>
			))}
		</Card>
	)
}
